import { createSlice } from "@reduxjs/toolkit";
import { setAxiosHeaders, setUserStorage } from "../utils/utils";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    user: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      if (action.payload && action.payload.token) {
        setAxiosHeaders(action.payload.token);
        setUserStorage(action.payload);
      } else {
        setAxiosHeaders("");
        setUserStorage(null);
      }
    },
    setToken: (state, action) => {
      if (action.payload) state.token = action.payload;
      else {
        state.token = null;
        state.user = null;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, setToken } = authSlice.actions;

export default authSlice.reducer;
